<template>
	<div class="bg-accented w-full">
		<UCollapsible
			@update:open="track('button_click', {
				action: $event ? 'open' : 'close',
				component_id: FAQ_BUTTON_ID,
				question: faq.question,
				location: trackingLocation
			})"
		>
			<UButton
				:id="FAQ_BUTTON_ID"
				:label="faq.question"
				variant="ghost"
				color="neutral"
				class="w-full flex justify-between font-semibold bg-accented first-of-type:my-2 text-lg text-left text-highlighted"
				trailing-icon="i-lucide-chevron-down"
				size="xl"
				:ui="{
					base: 'rounded-lg',
					label: 'text-wrap'
				}"
				@mouseenter="trackEvent($event, trackingLocation)"
				@focus="trackEvent($event, trackingLocation)"
			/>
			<template #content>
				<div class="text-muted mx-4 pb-4">
					<p v-html="faq.answer" />
				</div>
			</template>
		</UCollapsible>
	</div>
</template>

<script setup lang="ts">
import { useGA4Tracking } from '@/composables/useGA4Tracking'
import { FAQ_BUTTON_ID } from '@/constants/ga4/tracking-ids'
import type { FaqProps } from '@/types/components/faqs'

defineProps({
	faq: {
		type: Object as PropType<FaqProps>,
		required: true
	},
	trackingLocation: {
		type: String,
		required: true
	}
})

const {
	track, trackEvent
} = useGA4Tracking()
</script>
